(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["d3f-home-product"] && !Shopify.designMode) return;
  try {
    function updateFilamentCardVariant(card, option) {
  if (!card || !option) return;
  const price = card.querySelector('[data-fh-price-value]');
  if (price) price.textContent = option.dataset.price || '';
  for (const link of card.querySelectorAll('[data-fh-product-link]')) {
    if (option.dataset.url) link.setAttribute('href', option.dataset.url);
  }
  const image = card.querySelector('.fh-variant-image');
  if (image && option.dataset.image) {
    image.removeAttribute('srcset');
    image.setAttribute('src', option.dataset.image);
    image.setAttribute('alt', card.dataset.fhProductTitle + ' · ' + option.textContent.trim());
  }
}

document.addEventListener('change', (event) => {
  if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-fh-variant]')) return;
  updateFilamentCardVariant(event.target.closest('[data-fh-product]'), event.target.selectedOptions[0]);
});

document.addEventListener('toggle', (event) => {
  if (!(event.target instanceof HTMLDetailsElement) || !event.target.matches('.fh-quick')) return;
  const card = event.target.closest('[data-fh-product]');
  if (!card) return;
  if (event.target.open) {
    const select = card.querySelector('[data-fh-variant]');
    if (select) updateFilamentCardVariant(card, select.selectedOptions[0]);
    return;
  }
  const image = card.querySelector('.fh-variant-image');
  if (!image || !card.dataset.fhCoverUrl) return;
  image.removeAttribute('srcset');
  image.setAttribute('src', card.dataset.fhCoverUrl);
  image.setAttribute('alt', card.dataset.fhCoverAlt || card.dataset.fhProductTitle);
  for (const link of card.querySelectorAll('[data-fh-product-link]')) {
    link.setAttribute('href', card.dataset.fhProductUrl);
  }
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["d3m-filament-catalog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('d3m-filament-catalog')) {
    customElements.define('d3m-filament-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.grid = this.querySelector('[data-grid]');
        this.cards = Array.from(this.grid.children);
        this.material = this.querySelector('[data-material-select]');
        this.brand = this.querySelector('[data-brand-select]');
        this.line = this.querySelector('[data-line-select]');
        this.sort = this.querySelector('[data-sort-select]');
        this.status = this.querySelector('[role="status"]');
        this.empty = this.querySelector('[data-empty]');
        this.resetButtons = this.querySelectorAll('[data-reset]');
        this.querySelector('[data-filters]').hidden = false;
        this.onChange = event => {
          if (event.target === this.brand) this.line.value = '';
          this.update(true);
        };
        this.addEventListener('change', this.onChange);
        this.onClick = event => {
          if (!event.target.closest('[data-reset]')) return;
          this.material.value = '';
          this.brand.value = '';
          this.line.value = '';
          this.sort.value = 'featured';
          this.update(true);
        };
        this.addEventListener('click', this.onClick);
        this.onPopState = () => this.readUrl();
        window.addEventListener('popstate', this.onPopState);
        this.readUrl();
      }
      disconnectedCallback() {
        window.removeEventListener('popstate', this.onPopState);
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
        this.ready = false;
      }
      readUrl() {
        const params = new URL(window.location.href).searchParams;
        this.material.value = params.get('material') || '';
        this.brand.value = params.get('marca') || '';
        this.line.value = params.get('linea') || '';
        this.sort.value = params.get('orden') || 'featured';
        if (!this.sort.value) this.sort.value = 'featured';
        this.update(false);
      }
      update(writeUrl) {
        for (const option of this.line.options) {
          option.disabled = !!option.value && !!this.brand.value && option.dataset.brand !== this.brand.value;
        }
        if (this.line.selectedOptions[0]?.disabled) this.line.value = '';
        let count = 0;
        const ordered = [...this.cards];
        if (this.sort.value === 'price-asc') ordered.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
        if (this.sort.value === 'price-desc') ordered.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
        if (this.sort.value === 'title') ordered.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title, document.documentElement.lang));
        for (const card of ordered) {
          card.hidden = (!!this.material.value && card.dataset.material !== this.material.value) || (!!this.brand.value && card.dataset.brand !== this.brand.value) || (!!this.line.value && card.dataset.line !== this.line.value);
          if (!card.hidden) count++;
          this.grid.append(card);
        }
        this.status.textContent = this.dataset.countTemplate.replace('[count]', String(count));
        this.empty.hidden = count > 0;
        this.resetButtons[0].hidden = !this.material.value && !this.brand.value && !this.line.value && this.sort.value === 'featured';
        if (writeUrl) {
          const url = new URL(window.location.href);
          for (const [key, value] of [['material', this.material.value], ['marca', this.brand.value], ['linea', this.line.value], ['orden', this.sort.value === 'featured' ? '' : this.sort.value]]) {
            if (value) url.searchParams.set(key, value);
            else url.searchParams.delete(key);
          }
          window.history.pushState(null, '', url);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
